import { IReminderData } from './../personal_reminder_interface';
import { ReminderListDatastore } from './../datasources/personal_reminder_list_datasource';
import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ReminderConfirmDatasource } from '../datasources/create_reminder_datasource';
import { ORM, IDatasource } from 'utility-ts-orm';
import * as _4 from 'lodash4';

angular
  .module('data-ng-personal-reminders')
  .factory(
    'editReminderCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      reminderConfirmDatasource: ReminderConfirmDatasource,
      reminderListDatastore: ReminderListDatastore
    ): ICommand => {
      return defineCommand(
        'editReminderCommand',
        (deferred: ng.IDeferred<IQuery[]>, reminderID: string, reminderAPIValues: IReminderData): void => {
          $http
            .put(`event/todos/${reminderID}`, reminderAPIValues)
            .then((response: any) => {
              const oldData = _4.find(reminderListDatastore.read(), (x: any) => x.id === reminderID);
              const reminder = _4.merge(oldData, reminderAPIValues, {
                id: reminderID,
                due_ts: _4.isEmpty(reminderAPIValues.due_dt)
                  ? oldData.due_ts
                  : `${reminderAPIValues.due_dt}T${reminderAPIValues.due_tm}`
              });
              reminderConfirmDatasource.write(reminder);
              reminderListDatastore.updateReminder(reminder);
              ORM.run();
              deferred.resolve(ORM.run(reminderListDatastore));
              deferred.resolve(response);
            })
            .catch((error: any) => {
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/commands/edit_reminder_command.ts